import React from "react";

export default function TopUser({ UserPhoto }) {
  return (
    <>
      <div className="flex items-center">
        <img src={UserPhoto} alt="User" className="w-12 h-12 rounded-full" />
        <div className="ml-4">
          <p className="font-bold">Username</p>
          <p>Score</p>
        </div>
      </div>
    </>
  );
}
